import { TipoElementoEnum } from "../enum/tipo-elemento-enum";

export class ElementoVicinoVO {
    idElemento: string;
    tipoElemento: TipoElementoEnum;
}
